import type { MoodLevel } from '@shared/types';
import { BadFace, DownFace, GoodFace, GreatFace, OkayFace } from '../faces';

export interface IMoodUIDetails {
  faceEmoji: React.ReactNode;
  bgColor: string;
}

const moodMap: Record<MoodLevel, IMoodUIDetails> = {
  Great: { faceEmoji: <GreatFace />, bgColor: 'bg-mood-great' },
  Good: { faceEmoji: <GoodFace />, bgColor: 'bg-mood-good' },
  Okay: { faceEmoji: <OkayFace />, bgColor: 'bg-mood-okay' },
  Low: { faceEmoji: <DownFace />, bgColor: 'bg-mood-low' },
  Bad: { faceEmoji: <BadFace />, bgColor: 'bg-mood-bad' },
};

export const getMoodUI = (mood: MoodLevel): IMoodUIDetails => {
  return moodMap[mood];
};
